import { getTime } from '../../helpers';
import { BaseGamePadBaseDrawer } from './BaseGamePadBaseDrawer';
import { translationKeys } from '../../../../src/core/translation/translation';

export class BaseGamePadWebDrawer extends BaseGamePadBaseDrawer {
  constructor() {
    super();
    this.sourceNames = {
      ...this.sourceNames,
      roundedContainer: 'game_pad_web_drawer_rounded_container_icon',
      roundedContainerActive: 'game_pad_web_drawer_rounded_active_container_icon',
    };
  }

  getFooter({
    width = 1920,
    height = 30,
    providerName = 'Pascal Gaming',
    providerTitleStyle = {
      fontSize: 14,
      fill: 0xe3c632,
    },
    timeStyle = {
      fontSize: 14,
      fill: 0xFFFFFF,
    },
    alpha = .8,
  } = {}) {
    const footerContainer = this.createContainer('footerContainer');
    const rect = this.createGraphics()
      .beginFill(0x000000)
      .drawRect(
        0,
        0,
        width,
        height,
      );
    const providerText = this.createText(`Powered by ${providerName}`, providerTitleStyle);
    const timeText = new this.PIXI.Text(getTime(), timeStyle);

    this.ticker = setInterval(() => {
      timeText.text = getTime();
    }, 1000);

    rect.alpha = alpha;

    this.setPosition(providerText, { x: 25, y: 8 });
    this.setPosition(timeText, { x: 1860, y: 8 });

    footerContainer.addChild(
      rect,
      providerText,
      timeText,
    );

    return {
      container: footerContainer,
      provider: providerText,
      time: timeText,
      * [Symbol.iterator]() {
        yield this.container;
        yield this.provider;
        yield this.time;
      },
    };
  }

  getGamePadRect({
    width = 1920,
    height = 100,
    alpha = .4,
  } = {}) {
    const rectContainer = this.createContainer('gamePadRect');
    const rect = this.createGraphics()
      .beginFill(0x000000)
      .drawRect(
        0,
        0,
        width,
        height,
      );
    rect.alpha = alpha;
    this.setPosition(rect, { y: 0, x: 0 });
    rectContainer.addChild(rect);
    return rectContainer;
  }

  getAmountContent({
    onNext,
    onPrev,
    amountTextStyle = {},
  }) {
    const container = this.createContainer('betAmountContainer');
    const amountContent = this.createSprite(this.resources[this.sourceNames.roundedContainer]);
    const betAmountPlus = this.createSprite(this.resources[this.sourceNames.plusIcon]);
    const betAmountMinus = this.createSprite(this.resources[this.sourceNames.minusIcon]);
    const amountTextTexture = this.createText('', amountTextStyle);

    amountContent.anchor.set(.5);
    betAmountPlus.anchor.set(.5);
    betAmountMinus.anchor.set(.5);
    amountTextTexture.anchor.set(.5);

    this.setPosition(betAmountMinus, { x: -amountContent.width / 2 - betAmountMinus.width / 2 - 10 });
    this.setPosition(betAmountPlus, { x: amountContent.width / 2 + betAmountMinus.width / 2 + 10 });

    this.setupButtonMode(betAmountMinus);
    this.registerClick(betAmountMinus, event => {
      onPrev(event, {
        button: betAmountMinus,
      });
    });
    this.setupButtonMode(betAmountPlus);
    this.registerClick(betAmountPlus, event => {
      onNext(event, {
        button: betAmountPlus,
      });
    });

    container.addChild(
      amountContent,
      betAmountPlus,
      betAmountMinus,
      amountTextTexture,
    );

    return {
      container,
      renderOption: value => {
        amountTextTexture.text = value;
      },
      elements: {
        next: betAmountPlus,
        prev: betAmountMinus,
      },
      * [Symbol.iterator]() {
        yield this.container;
        yield this.renderOption;
        yield this.elements;
      },
    };
  }

  getAutoSpinContent({
    onNext,
    onPrev,
    valueStyle = {},
    textStyle = {},
  }) {
    const container = this.createContainer('betAmountContainer');
    const roundedSpinContainer = this.createContainer('roundedSpinContainer');
    const rightArrowContainer = this.createContainer('rightArrowContainer');
    const leftArrowContainer = this.createContainer('leftArrowContainer');

    const roundedContainer = this.createSprite(this.resources[this.sourceNames.roundedContainer]);
    const roundedSpinContainerTexture = this.createSprite(roundedContainer);
    const roundedContainerActive = this.createSprite(this.resources[this.sourceNames.roundedContainerActive]);
    const rightArrowIcon = this.createSprite(this.resources[this.sourceNames.rightArrowIcon]);
    const leftArrowIcon = this.createSprite(this.resources[this.sourceNames.leftArrowIcon]);
    const rightArrowCircle = this.createGraphics().beginFill(0x636363).drawCircle(0, 0, 23).endFill();
    const leftArrowCircle = this.createGraphics().beginFill(0x636363).drawCircle(0, 0, 23).endFill();
    const countTextTexture = this.createText('', valueStyle);
    const titleTextTexture = this.createText(translationKeys.autoSpin, textStyle);
    const infinityIconTexture = this.getTexture({
      name: this.sourceNames.infinityIcon,
      scale: 1,
    });

    roundedContainerActive.visible = false;

    roundedSpinContainerTexture.anchor.set(.5);
    roundedContainerActive.anchor.set(.5);
    countTextTexture.anchor.set(.5);
    roundedContainer.anchor.set(.5);
    rightArrowIcon.anchor.set(.5);
    leftArrowIcon.anchor.set(.5);
    titleTextTexture.anchor.set(.5);
    infinityIconTexture.anchor.set(.5);

    this.setPosition(leftArrowContainer, { x: -roundedContainer.width / 2 + leftArrowIcon.width / 2 });
    this.setPosition(rightArrowContainer, { x: roundedContainer.width / 2 - rightArrowIcon.width / 2 });
    this.setPosition(roundedSpinContainer, { x: 0, y: -roundedSpinContainerTexture.height - 10 });

    this.setupButtonMode(leftArrowIcon);
    this.registerClick(leftArrowIcon, event => {
      onPrev(event, {
        button: leftArrowIcon,
      });
    });

    this.setupButtonMode(rightArrowIcon);
    this.registerClick(rightArrowIcon, event => {
      onNext(event, {
        button: rightArrowIcon,
      });
    });


    rightArrowContainer.addChild(
      rightArrowCircle,
      rightArrowIcon,
    );

    leftArrowContainer.addChild(
      leftArrowCircle,
      leftArrowIcon,
    );

    roundedSpinContainer.addChild(
      roundedSpinContainerTexture,
      rightArrowContainer,
      leftArrowContainer,
      countTextTexture,
      infinityIconTexture,
    );

    container.addChild(
      roundedContainer,
      roundedContainerActive,
      roundedSpinContainer,
      titleTextTexture,
    );

    return {
      container,
      renderOption: value => {
        const isInfinity = value === Infinity;
        infinityIconTexture.visible = isInfinity;
        countTextTexture.alpha = !+isInfinity;
        countTextTexture.text = value;
      },
      onToggle: (state) => {
        roundedContainerActive.visible = state;
        roundedSpinContainer.visible = state;
        titleTextTexture.text = state ? translationKeys.play : translationKeys.autoSpin;
      },
      elements: {
        content: roundedContainer,
        next: rightArrowCircle,
        prev: leftArrowCircle,
      },
      * [Symbol.iterator]() {
        yield this.container;
        yield this.renderOption;
        yield this.onToggle;
        yield this.elements;
      },
    };
  }
}
